import {ChevronRightIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'

import styles from './ExpandableSectionIcon.module.css'

export const ExpandableSectionIcon = ({isExpanded}: {isExpanded: boolean}) => {
  return (
    <div className={clsx(styles.icon, isExpanded && styles.isExpanded)}>
      <ChevronRightIcon />
    </div>
  )
}
